export const BEGIN_AJAX_CALL = 'BEGIN_AJAX_CALL';
export const AJAX_CALL_ERROR = 'AJAX_CALL_ERROR';



/** WEBPACK FOOTER **
 ** ./src/actions/actionTypes.js
 **/